(function () {
    "use strict";

    angular.module("app.option").factory("OptionValuesService", Service);

    Service.$inject = ["$http", "$location", "$q", "ngAuthSettings", "logger", "config", "Settings"];

    function Service($http, $location, $q, ngAuthSettings, logger, config, Settings) {
        var service = {
            getAll: getAll,
            getAllOption: getAllOption,
            getOptionValue: getOptionValue,
            get: get,
            add: add,
            edit: edit,
            del: del,
            getFields: getFields
        };
        var baseUrl = ngAuthSettings.apiServiceBaseUri;
        var serviceBaseUrl = baseUrl + "api/OptionValues/";

        var fields = [{
                key: "Value",
                type: "horizontalInput",
                templateOptions: {
                    required: true,
                    type: "text",
                    resource: "form.option-value",
                    label: "Adı",
                    placeholder: "Adı"
                }
            },
            {
                key: "TopOptionValueId",
                type: "horizontalSelect",
                templateOptions: {
                    label: "Üst Değer",
                    labelProp: "Value",
                    resource: "form.top-value",
                    options: [{
                        Name: "Yükleniyor..."
                    }]
                },
                controller: [
                    "$scope",
                    function ($scope) {
                        $scope.$watch("model.OptionId", function (newValue, oldValue) {
                            if (newValue) {
                                getAllOption({
                                    PageSize: -1,
                                    OptionId: newValue
                                }).then(function (response) {
                                    $scope.to.options = response.Data;
                                });
                            }
                        });
                    }
                ]
            },
            {
                key: "DisplayOrder",
                type: "horizontalInput",
                templateOptions: {
                    required: true,
                    type: "number",
                    resource: "form.display-order",
                    label: "Sıra",
                    placeholder: "Sıra"
                }
            },
            {
                key: "Description",
                type: "horizontalTinyMCE",
                templateOptions: {
                    label: "Açıklama",
                    placeholder: "İçerik",
                    resource: "form.description"
                }
            },
        ];

        return service;

        /////////////////////////////////////////

        function getFields() {
            return fields;
        }

        function getAllOption(filter) {
            var deferred = $q.defer();
            $http
                .get(serviceBaseUrl + "All", {
                    params: filter
                })
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getAll(optionId) {
            var deferred = $q.defer();

            $http
                .get(serviceBaseUrl + optionId + "?PageSize=-1")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getOptionValue(optionId) {
            var deferred = $q.defer();

            $http
                .get(serviceBaseUrl + optionId)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function get(productId, optionId, Id) {
            var deferred = $q.defer();

            $http
                .get(serviceBaseUrl + Id)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function add(entity) {
            var deferred = $q.defer();

            $http
                .post(serviceBaseUrl, entity)
                .then(editComplete)
                .catch(editFailed);

            function editComplete(response) {
                deferred.resolve(response.data);
            }

            function editFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function edit(entity) {
            var deferred = $q.defer();

            $http
                .put(serviceBaseUrl + entity.Id, entity)
                .then(editComplete)
                .catch(editFailed);

            function editComplete(response) {
                deferred.resolve(response.data);
            }

            function editFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function del(entity) {
            var deferred = $q.defer();

            $http
                .delete(serviceBaseUrl + entity.Id, entity)
                .then(editComplete)
                .catch(editFailed);

            function editComplete(response) {
                deferred.resolve(response.data);
            }

            function editFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
    }
})();